<template>
  <Popup :preventTouchMove="false" :useAbsolutePosition="useAbsolutePosition" :isShow="toggle"
    :bottomDistance="bottomDistance" class="modal-channels" @mask-click="handleMaskClick">
    <header class="header" @click="handleMaskClick">
      <img src="./assets/icon-down.svg" class="icon" />
    </header>
    <ScrollView class="channel-list" tag="ul" @touchmove.native="handleTouchmove">
      <template v-if="supportChannels.length > 0">
        <li v-for="(item, index) in supportChannels" :key="index" class="channel-item-wrap"
          @click="handleSelectChannel(index, item)">
          <div v-if="
            item.type !== HUABEI ||
            (item.type === HUABEI && huabeiList.length)
          ">
            <div class="channel-item">
              <div class="icon-wrapper">
                <img class="icon" :src="item.icon" />
              </div>
              <div class="channel">
                <span>{{ item.title }}</span>
                <div class="check-box" :class="{ checked: index === channelIndex }"></div>
              </div>
            </div>
            <div v-if="item.type === HUABEI && index === channelIndex" class="drawer-wrap">
              <div v-for="(item, index) in huabeiAmountList" :key="index" class="drawer-sub-panel"
                :class="{ active: +item.plan_id === huabeiTerm }" @click="handleChooseTerm(item.plan_id)">
                <div class="main-text">
                  ¥{{ item.amount }} x {{ item.plan_id }}期
                </div>
                <div class="sub-text">{{ desc }}</div>
              </div>
            </div>
          </div>
        </li>
      </template>
      <div v-else class="no-channel">暂无支持支付方式，请稍后重试</div>
    </ScrollView>
    <slot name="footer"></slot>
  </Popup>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Popup from '@/components/Popup';
import ScrollView from '@/components/ScrollView';
import { allChannels, PayTypes, IPayType, IHuabeiTermInfo } from './index';

const defaultHuabeiTerm = 12; // 花呗分期默认选中12期

@Component({
  components: {
    Popup,
    ScrollView,
  },
})
export default class ModalChannelSelect extends Vue {
  @Prop({ type: Boolean, default: false }) toggle!: boolean;
  @Prop({ type: String }) price!: string;
  @Prop({
    type: Array,
    default: () => [PayTypes.wechat, PayTypes.alipay],
  })
  supportType!: PayTypes[];
  @Prop({
    type: Array,
    default: () => [],
  })
  huabeiList!: IHuabeiTermInfo[];
  @Prop({ type: Number, default: 0 }) huabeiTotalAmount!: number;
  @Prop({ type: Number, require: true }) productionId!: number;
  @Prop({ type: String }) title!: string;
  @Prop({ type: Boolean, default: false }) useAbsolutePosition!: boolean;
  @Prop({ type: String, default: 'wechat' }) defaultType!: PayTypes;
  @Prop({ type: String, default: '0px' }) bottomDistance!: string;

  channelIndex = 0;
  isHandlePaying = false;

  HUABEI = PayTypes.huabei;

  huabeiTerm = defaultHuabeiTerm;
  sellerPercent = 0;

  get huabeiAmountList() {
    return this.huabeiList.map((item) => {
      const freeInterestVal = 100;
      let totalAmount = this.huabeiTotalAmount;
      if (Number(this.sellerPercent) !== freeInterestVal) {
        // 非免息，加汇率
        totalAmount = this.huabeiTotalAmount * (1 + Number(item.rate));
      }

      // totalAmount / item.plan_id 期数 / 100 价格（分）/ 100（分->元）
      // 四舍五入保留2位小数
      item.amount = Math.round((totalAmount / item.plan_id / 100) * 100) / 100;

      return item;
    });
  }

  get supportChannels() {
    const result = [];
    for (const item of this.supportType) {
      const channel = allChannels[item];
      if (channel) {
        result.push(channel);
      }
    }
    return result;
  }
  get hasHuabei() {
    return !!this.supportType.filter((item) => item === this.HUABEI).length;
  }
  get isPreventTouchmove() {
    if (
      this.hasHuabei &&
      this.channelIndex === this.supportType.indexOf(this.HUABEI) // 拥有分期&&当前选中分期（超出maxheight）
    ) {
      return this.supportChannels.length < 4;
    } else {
      return this.supportChannels.length <= 5;
    }
  }

  get desc() {
    const open_val = 100;
    return Number(this.sellerPercent) === open_val ? '免息' : '(含手续费)';
  }

  mounted() {
    this.getSellerPercent();
  }
  async getSellerPercent() {
    if (!this.$route.query.c_id) {
      return;
    }

    try {
      const { data } = await window.apis.getCouponInfo({
        c_id: this.$route.query.c_id,
      });
      data.seller_percent && (this.sellerPercent = data.seller_percent);
    } catch (error) { }
  }

  @Watch('defaultType', { immediate: true })
  onDefaultTypeChanged(val: string, oldVal: string) {
    if (val === oldVal) {
      return;
    }
    for (let i = 0; i < this.supportChannels.length; i++) {
      if (this.defaultType === this.supportChannels[i].type) {
        this.channelIndex = i;
        break;
      }
    }
  }
  handleSelectChannel(selectIndex: number, channel: IPayType) {
    this.channelIndex = selectIndex;
    const _term =
      channel.type === PayTypes.huabei ? this.huabeiTerm : undefined;

    this.$emit('change', channel, _term);
  }
  handleTouchmove(e: Event) {
    if (this.isPreventTouchmove) {
      e.preventDefault();
    }
  }
  handleMaskClick() {
    this.$emit('close');
  }
  handleChooseTerm(term: number) {
    this.huabeiTerm = term;
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';

@mixin border($property) {
  #{$property}: solid 0.5px rgba($color: #ceccd7, $alpha: 0.4);
}

.modal-channels {
  .header {
    @include flex-center;
    height: 50px;
    color: #3b3561;
    font-weight: 600;
    font-size: 36px;
    letter-spacing: 3.6px;
  }

  .channel-list {
    min-height: 475px;
    max-height: 734px;
    padding: 0 57px;

    .channel-item-wrap:not(:last-child) {
      // .channel {
      @include border(border-bottom);
      // }
    }
  }

  .channel-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 130px;
    .icon-wrapper {
      width: 88px;
    }

    .icon {
      width: 57px;
    }

    .channel {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      color: #3b3561;
      font-size: 32px;
      letter-spacing: 3.2px;

      .check-box {
        width: 42px;
        height: 42px;
        border: solid 3px rgba(59, 53, 97, 0.25);
        border-radius: 50%;

        &.checked {
          background: url('./assets/icon-check.svg') center/cover no-repeat;
          border: none;
        }
      }
    }
  }

  .drawer-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 22px;
  }

  .drawer-sub-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 296px;
    height: 104px;
    margin-bottom: 18px;
    background-color: rgba(247, 249, 254, 1);
    border: 2px solid rgba(247, 249, 254, 1);
    border-radius: 8px;

    &.active {
      border-color: #6854f0;
    }

    .main-text {
      color: #31285d;
      font-size: 26px;
    }

    .sub-text {
      color: rgba(49, 40, 93, 0.4);
      font-size: 22px;
    }
  }

  .no-channel {
    padding: 30px 0;
    color: #3b3561;
    font-size: 36px;
    text-align: center;
  }
}
</style>